import React from 'react';
import styled from 'styled-components';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import UnitBuilder from '../builder/UnitBuilder';

const StyledCard = styled.div`
  margin: 10px;
  display: flex;
  flex-direction: column;
  border: solid 1px #999999;
  width: ${({ isFullSize }) => (isFullSize ? '100%' : 'calc(50% - 22px)')};
  opacity: ${({ isDragging }) => (isDragging ? '0.5' : '1')};
  min-width: 632px;
  height: 40vh;
  min-height: 360px;
  background: #ffffff;
`;

const ManagerUnitCard = ({ unit, id, isFullSize, ...props }) => {
  const { isDragging, attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id,
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
  };

  return (
    <StyledCard ref={setNodeRef} style={style} isDragging={isDragging} isFullSize={isFullSize}>
      <UnitBuilder unit={unit} dragOptions={{ ...attributes, ...listeners }} {...props} />
    </StyledCard>
  );
};

export default ManagerUnitCard;
